import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "officeName"
})
export class OfficeNamePipe implements PipeTransform {
  transform(offices: NsEmpWebExpData.IOffice[], value: string): string {
    if (!offices || !offices.length || !value) {
      return "";
    }
    const ofc = offices.find(o => o.guid === value);
    return ofc?.address || value;
  }
}
